import CategoryFilter from "./categoryFilter"

export default CategoryFilter
